import React from 'react';
import { withTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import ButtonTooltip from '@core/dashboard/components/ButtonTooltip';
import UserAvatar from '@components/UserAvatar';
import UserProfileModal from '@components/UserProfileModalNew';
import PulsingBorder from '@components/PulsingBorder';
import { TutorialHighlightKey, useTutorialHighlight } from '@core/tutorials';

import { IUserAvatarButtonView } from './interfaces';
import { useStyle } from './styles';

const UserAvatarButtonView = ({
  profileImage = '',
  name = '',
  showUserSettingModal,
  toggleModal,
  t: translate,
}: IUserAvatarButtonView) => {
  const classes = useStyle();
  const isProfileButtonHighlighted = useTutorialHighlight(
    TutorialHighlightKey.ProfileAvatarButton,
  );

  return (
    <>
      <ButtonTooltip title={translate('tooltips.myAccount')}>
        <PulsingBorder
          active={isProfileButtonHighlighted}
          borderRadius="50%"
          sx={classes.wrapper}
        >
          <Box sx={classes.root} data-testid="user-profile-avatar-btn">
            <UserAvatar
              name={name}
              onClick={toggleModal}
              src={profileImage}
              sx={classes.avatar}
            />
          </Box>
        </PulsingBorder>
      </ButtonTooltip>

      <UserProfileModal isOpen={showUserSettingModal} onClose={toggleModal} />
    </>
  );
};

export default withTranslation()(UserAvatarButtonView);
